function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.882
    },
    fill: "#427fc4",
    d: "M 27.5,-0.5 C 27.8333,-0.5 28.1667,-0.5 28.5,-0.5C 28.5,4.83333 28.5,10.1667 28.5,15.5C 23.8107,12.8226 22.3107,8.82263 24,3.5C 24.6897,1.64977 25.8564,0.316435 27.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#4279c4",
    d: "M 28.5,-0.5 C 34.5,-0.5 40.5,-0.5 46.5,-0.5C 46.5,41.8333 46.5,84.1667 46.5,126.5C 40.8413,119 37.1746,110.5 35.5,101C 33.5076,99.0018 31.1743,97.5018 28.5,96.5C 28.176,89.6457 28.5093,82.979 29.5,76.5C 30.8149,77.4756 32.1482,78.4756 33.5,79.5C 34.4988,68.5202 34.8321,57.5202 34.5,46.5C 32.5,46.5 30.5,46.5 28.5,46.5C 28.5,41.1667 28.5,35.8333 28.5,30.5C 30.5,30.5 32.5,30.5 34.5,30.5C 34.5,25.5 34.5,20.5 34.5,15.5C 32.5,15.5 30.5,15.5 28.5,15.5C 28.5,10.1667 28.5,4.83333 28.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#4074c5",
    d: "M 46.5,-0.5 C 50.8333,-0.5 55.1667,-0.5 59.5,-0.5C 59.5,4.83333 59.5,10.1667 59.5,15.5C 56.8333,15.5 54.1667,15.5 51.5,15.5C 51.3334,42.5021 51.5,69.5021 52,96.5C 53.3689,104.447 56.2023,111.78 60.5,118.5C 59.5084,125.648 59.175,132.981 59.5,140.5C 53.7815,137.115 49.4481,132.448 46.5,126.5C 46.5,84.1667 46.5,41.8333 46.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3f6dc7",
    d: "M 59.5,-0.5 C 62.8333,-0.5 66.1667,-0.5 69.5,-0.5C 69.5,4.83333 69.5,10.1667 69.5,15.5C 66.1667,15.5 62.8333,15.5 59.5,15.5C 59.5,10.1667 59.5,4.83333 59.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3f67c7",
    d: "M 69.5,-0.5 C 74.8333,-0.5 80.1667,-0.5 85.5,-0.5C 85.5,4.83333 85.5,10.1667 85.5,15.5C 80.1667,15.5 74.8333,15.5 69.5,15.5C 69.5,10.1667 69.5,4.83333 69.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3e61c7",
    d: "M 85.5,-0.5 C 86.8333,-0.5 88.1667,-0.5 89.5,-0.5C 89.5,4.83333 89.5,10.1667 89.5,15.5C 88.1667,15.5 86.8333,15.5 85.5,15.5C 85.5,10.1667 85.5,4.83333 85.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d60c8",
    d: "M 89.5,-0.5 C 91.5,-0.5 93.5,-0.5 95.5,-0.5C 95.5,4.83333 95.5,10.1667 95.5,15.5C 93.5,15.5 91.5,15.5 89.5,15.5C 89.5,10.1667 89.5,4.83333 89.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d5cc8",
    d: "M 95.5,-0.5 C 97.8333,-0.5 100.167,-0.5 102.5,-0.5C 102.5,4.83333 102.5,10.1667 102.5,15.5C 100.167,15.5 97.8333,15.5 95.5,15.5C 95.5,10.1667 95.5,4.83333 95.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3b56c8",
    d: "M 102.5,-0.5 C 103.833,-0.5 105.167,-0.5 106.5,-0.5C 106.5,4.83333 106.5,10.1667 106.5,15.5C 105.167,15.5 103.833,15.5 102.5,15.5C 102.5,10.1667 102.5,4.83333 102.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3c53c7",
    d: "M 106.5,-0.5 C 107.833,-0.5 109.167,-0.5 110.5,-0.5C 110.5,4.83333 110.5,10.1667 110.5,15.5C 109.167,15.5 107.833,15.5 106.5,15.5C 106.5,10.1667 106.5,4.83333 106.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#394dc7",
    d: "M 110.5,-0.5 C 112.5,-0.5 114.5,-0.5 116.5,-0.5C 116.5,4.83333 116.5,10.1667 116.5,15.5C 114.5,15.5 112.5,15.5 110.5,15.5C 110.5,10.1667 110.5,4.83333 110.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3948c7",
    d: "M 116.5,-0.5 C 117.5,-0.5 118.5,-0.5 119.5,-0.5C 119.5,4.83333 119.5,10.1667 119.5,15.5C 118.5,15.5 117.5,15.5 116.5,15.5C 116.5,10.1667 116.5,4.83333 116.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3844c7",
    d: "M 119.5,-0.5 C 120.5,-0.5 121.5,-0.5 122.5,-0.5C 122.5,4.83333 122.5,10.1667 122.5,15.5C 121.5,15.5 120.5,15.5 119.5,15.5C 119.5,10.1667 119.5,4.83333 119.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3740c7",
    d: "M 122.5,-0.5 C 124.5,-0.5 126.5,-0.5 128.5,-0.5C 128.5,4.83333 128.5,10.1667 128.5,15.5C 126.5,15.5 124.5,15.5 122.5,15.5C 122.5,10.1667 122.5,4.83333 122.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#363cc7",
    d: "M 128.5,-0.5 C 130.167,-0.5 131.833,-0.5 133.5,-0.5C 133.5,4.83333 133.5,10.1667 133.5,15.5C 131.833,15.5 130.167,15.5 128.5,15.5C 128.5,10.1667 128.5,4.83333 128.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3636c6",
    d: "M 133.5,-0.5 C 136.167,-0.5 138.833,-0.5 141.5,-0.5C 141.5,4.83333 141.5,10.1667 141.5,15.5C 138.833,15.5 136.167,15.5 133.5,15.5C 133.5,10.1667 133.5,4.83333 133.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.93
    },
    fill: "#3c34c5",
    d: "M 141.5,-0.5 C 144.167,-0.5 146.833,-0.5 149.5,-0.5C 149.5,42.8333 149.5,86.1667 149.5,129.5C 142.632,131.316 138.632,128.65 137.5,121.5C 142.139,113.752 145.306,105.419 147,96.5C 147.5,69.5021 147.667,42.5021 147.5,15.5C 145.5,15.5 143.5,15.5 141.5,15.5C 141.5,10.1667 141.5,4.83333 141.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#4132c5",
    d: "M 149.5,-0.5 C 152.833,-0.5 156.167,-0.5 159.5,-0.5C 159.5,37.5 159.5,75.5 159.5,113.5C 158.168,120.149 154.835,125.482 149.5,129.5C 149.5,86.1667 149.5,42.8333 149.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.928
    },
    fill: "#4730c5",
    d: "M 159.5,-0.5 C 162.167,-0.5 164.833,-0.5 167.5,-0.5C 167.5,4.83333 167.5,10.1667 167.5,15.5C 166.5,15.5 165.5,15.5 164.5,15.5C 164.5,20.5 164.5,25.5 164.5,30.5C 165.5,30.5 166.5,30.5 167.5,30.5C 167.5,35.8333 167.5,41.1667 167.5,46.5C 166.5,46.5 165.5,46.5 164.5,46.5C 163.856,57.8842 164.523,68.8842 166.5,79.5C 167.49,85.31 167.823,91.31 167.5,97.5C 166.019,98.4212 164.686,99.5879 163.5,101C 162.835,105.492 161.502,109.658 159.5,113.5C 159.5,75.5 159.5,37.5 159.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#4d2fc5",
    d: "M 167.5,-0.5 C 168.833,-0.5 170.167,-0.5 171.5,-0.5C 176.773,4.57663 176.773,9.74329 171.5,15C 170.207,15.49 168.873,15.6567 167.5,15.5C 167.5,10.1667 167.5,4.83333 167.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#4386c3",
    d: "M 17.5,30.5 C 17.5,49.5 17.5,68.5 17.5,87.5C 10.3316,81.5028 5.99828,73.8362 4.5,64.5C 4.5,54.1667 4.5,43.8333 4.5,33.5C 5.05773,32.2101 6.05773,31.3768 7.5,31C 10.8168,30.5017 14.1501,30.335 17.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#4280c4",
    d: "M 17.5,30.5 C 21.1667,30.5 24.8333,30.5 28.5,30.5C 28.5,35.8333 28.5,41.1667 28.5,46.5C 25.5,46.5 22.5,46.5 19.5,46.5C 18.2595,58.112 21.5928,68.112 29.5,76.5C 28.5093,82.979 28.176,89.6457 28.5,96.5C 23.9372,94.6046 20.2705,91.6046 17.5,87.5C 17.5,68.5 17.5,49.5 17.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4e2fc4",
    d: "M 167.5,30.5 C 170.5,30.5 173.5,30.5 176.5,30.5C 176.5,35.8333 176.5,41.1667 176.5,46.5C 173.5,46.5 170.5,46.5 167.5,46.5C 167.5,41.1667 167.5,35.8333 167.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#542dc4",
    d: "M 176.5,30.5 C 179.833,30.5 183.167,30.5 186.5,30.5C 186.17,47.6749 186.503,64.6749 187.5,81.5C 184.5,85.1667 181.167,88.5 177.5,91.5C 176.533,83.5856 176.199,75.5856 176.5,67.5C 179.072,60.7587 180.072,53.7587 179.5,46.5C 178.5,46.5 177.5,46.5 176.5,46.5C 176.5,41.1667 176.5,35.8333 176.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#5a2cc4",
    d: "M 186.5,30.5 C 189.831,30.0181 192.497,31.0181 194.5,33.5C 194.5,43.8333 194.5,54.1667 194.5,64.5C 193.543,70.7455 191.21,76.4122 187.5,81.5C 186.503,64.6749 186.17,47.6749 186.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.713
    },
    fill: "#428ac3",
    d: "M 4.5,33.5 C 4.5,43.8333 4.5,54.1667 4.5,64.5C 2.97147,59.084 2.3048,53.4173 2.5,47.5C 2.66667,43.5 2.83333,39.5 3,35.5C 3.27842,34.5842 3.77842,33.9175 4.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.911
    },
    fill: "#5d2ac4",
    d: "M 194.5,33.5 C 195.222,33.9175 195.722,34.5842 196,35.5C 196.167,39.5 196.333,43.5 196.5,47.5C 196.695,53.4173 196.029,59.084 194.5,64.5C 194.5,54.1667 194.5,43.8333 194.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.865
    },
    fill: "#3e61c7",
    d: "M 89.5,48.5 C 89.5,53.8333 89.5,59.1667 89.5,64.5C 87.2512,63.9202 85.5846,62.5869 84.5,60.5C 85.8333,58.1667 85.8333,55.8333 84.5,53.5C 85.1667,50.8333 86.8333,49.1667 89.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#3d60c8",
    d: "M 89.5,48.5 C 91.5,48.5 93.5,48.5 95.5,48.5C 95.5,65.1667 95.5,81.8333 95.5,98.5C 93.5,98.5 91.5,98.5 89.5,98.5C 89.5,93.1667 89.5,87.8333 89.5,82.5C 90.8142,80.0849 91.4809,77.2515 91.5,74C 91.3333,71.1667 91.1667,68.3333 91,65.5C 90.6174,64.944 90.1174,64.6107 89.5,64.5C 89.5,59.1667 89.5,53.8333 89.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3d5cc8",
    d: "M 95.5,48.5 C 97.8333,48.5 100.167,48.5 102.5,48.5C 102.5,65.1667 102.5,81.8333 102.5,98.5C 100.167,98.5 97.8333,98.5 95.5,98.5C 95.5,81.8333 95.5,65.1667 95.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3b56c8",
    d: "M 102.5,48.5 C 103.833,48.5 105.167,48.5 106.5,48.5C 106.5,65.1667 106.5,81.8333 106.5,98.5C 105.167,98.5 103.833,98.5 102.5,98.5C 102.5,81.8333 102.5,65.1667 102.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#3c53c7",
    d: "M 106.5,48.5 C 108.099,48.2322 109.432,48.5655 110.5,49.5C 110.5,54.5 110.5,59.5 110.5,64.5C 109.504,64.4142 108.671,64.7476 108,65.5C 107.501,71.1569 107.334,76.8236 107.5,82.5C 108.791,82.2627 109.791,82.596 110.5,83.5C 110.5,88.1667 110.5,92.8333 110.5,97.5C 109.432,98.4345 108.099,98.7678 106.5,98.5C 106.5,81.8333 106.5,65.1667 106.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.807
    },
    fill: "#3a4ec7",
    d: "M 110.5,49.5 C 115.36,52.2623 116.527,56.2623 114,61.5C 112.961,62.7101 111.794,63.7101 110.5,64.5C 110.5,59.5 110.5,54.5 110.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.653
    },
    fill: "#3f64c7",
    d: "M 84.5,53.5 C 85.8333,55.8333 85.8333,58.1667 84.5,60.5C 83.3139,58.1256 83.3139,55.7922 84.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.918
    },
    fill: "#4e2fc4",
    d: "M 176.5,67.5 C 176.199,75.5856 176.533,83.5856 177.5,91.5C 174.839,94.5023 171.505,96.5023 167.5,97.5C 167.823,91.31 167.49,85.31 166.5,79.5C 170.24,75.7672 173.573,71.7672 176.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.887
    },
    fill: "#3e61c7",
    d: "M 89.5,82.5 C 89.5,87.8333 89.5,93.1667 89.5,98.5C 87.246,97.8763 85.5794,96.543 84.5,94.5C 85.4731,92.0521 85.8064,89.3854 85.5,86.5C 85.894,84.2901 87.2273,82.9568 89.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.809
    },
    fill: "#3a4ec7",
    d: "M 110.5,83.5 C 113.766,84.5368 115.433,86.8701 115.5,90.5C 115.433,94.1299 113.766,96.4632 110.5,97.5C 110.5,92.8333 110.5,88.1667 110.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.636
    },
    fill: "#3f64c7",
    d: "M 85.5,86.5 C 85.8064,89.3854 85.4731,92.0521 84.5,94.5C 82.9241,91.5043 83.2574,88.8376 85.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#3f6dc7",
    d: "M 60.5,118.5 C 63.1395,121.806 66.1395,124.806 69.5,127.5C 69.5,134.167 69.5,140.833 69.5,147.5C 65.5899,145.912 62.2565,143.579 59.5,140.5C 59.175,132.981 59.5084,125.648 60.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#3f67c7",
    d: "M 69.5,127.5 C 74.5767,131.036 79.9101,134.036 85.5,136.5C 85.5,148.5 85.5,160.5 85.5,172.5C 85.2523,175.58 84.5856,178.58 83.5,181.5C 83.7472,182.713 84.4138,183.38 85.5,183.5C 85.5,188.833 85.5,194.167 85.5,199.5C 80.1667,199.5 74.8333,199.5 69.5,199.5C 69.5,189.833 69.5,180.167 69.5,170.5C 70.772,163.912 72.4387,157.412 74.5,151C 73.1843,149.341 71.5176,148.175 69.5,147.5C 69.5,140.833 69.5,134.167 69.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.924
    },
    fill: "#3e61c7",
    d: "M 85.5,136.5 C 86.9587,136.433 88.2921,136.766 89.5,137.5C 89.1765,144.022 89.5098,150.355 90.5,156.5C 89.1241,162.027 87.4575,167.36 85.5,172.5C 85.5,160.5 85.5,148.5 85.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#394dc7",
    d: "M 116.5,136.5 C 116.829,151.676 116.496,166.676 115.5,181.5C 113.519,174.911 111.853,168.244 110.5,161.5C 110.5,153.5 110.5,145.5 110.5,137.5C 112.265,136.539 114.265,136.205 116.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#3948c7",
    d: "M 116.5,136.5 C 117.71,136.932 118.71,137.599 119.5,138.5C 119.5,158.833 119.5,179.167 119.5,199.5C 118.5,199.5 117.5,199.5 116.5,199.5C 116.821,193.974 116.488,188.64 115.5,183.5C 115.5,182.833 115.5,182.167 115.5,181.5C 116.496,166.676 116.829,151.676 116.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#3d60c8",
    d: "M 89.5,137.5 C 91.6208,137.325 93.6208,137.659 95.5,138.5C 95.5,143.833 95.5,149.167 95.5,154.5C 93.2188,154.077 91.5521,154.744 90.5,156.5C 89.5098,150.355 89.1765,144.022 89.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#3b56c8",
    d: "M 106.5,137.5 C 106.5,143.167 106.5,148.833 106.5,154.5C 105.167,154.5 103.833,154.5 102.5,154.5C 102.5,149.167 102.5,143.833 102.5,138.5C 103.833,138.167 105.167,137.833 106.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#3c53c7",
    d: "M 106.5,137.5 C 107.833,137.5 109.167,137.5 110.5,137.5C 110.5,145.5 110.5,153.5 110.5,161.5C 109.603,158.836 108.27,156.502 106.5,154.5C 106.5,148.833 106.5,143.167 106.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#3d5cc8",
    d: "M 95.5,138.5 C 97.8333,138.5 100.167,138.5 102.5,138.5C 102.5,143.833 102.5,149.167 102.5,154.5C 100.167,154.5 97.8333,154.5 95.5,154.5C 95.5,149.167 95.5,143.833 95.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#3845c7",
    d: "M 119.5,138.5 C 121.584,141.053 122.917,144.053 123.5,147.5C 122.503,164.659 122.17,181.992 122.5,199.5C 121.5,199.5 120.5,199.5 119.5,199.5C 119.5,179.167 119.5,158.833 119.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#3740c7",
    d: "M 123.5,147.5 C 125.5,154.5 127.5,161.5 129.5,168.5C 128.506,178.653 128.172,188.986 128.5,199.5C 126.5,199.5 124.5,199.5 122.5,199.5C 122.17,181.992 122.503,164.659 123.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#363cc7",
    d: "M 129.5,168.5 C 130.833,173.5 132.167,178.5 133.5,183.5C 133.5,188.833 133.5,194.167 133.5,199.5C 131.833,199.5 130.167,199.5 128.5,199.5C 128.172,188.986 128.506,178.653 129.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#3f6cc7",
    d: "M 69.5,170.5 C 69.5,180.167 69.5,189.833 69.5,199.5C 66.1667,199.5 62.8333,199.5 59.5,199.5C 59.5,194.167 59.5,188.833 59.5,183.5C 61.604,183.799 63.604,183.466 65.5,182.5C 66.6682,178.329 68.0015,174.329 69.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#4279c4",
    d: "M 46.5,183.5 C 46.5,188.833 46.5,194.167 46.5,199.5C 42.1667,199.5 37.8333,199.5 33.5,199.5C 28.2268,194.423 28.2268,189.257 33.5,184C 37.8206,183.501 42.1539,183.334 46.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4073c6",
    d: "M 46.5,183.5 C 50.8333,183.5 55.1667,183.5 59.5,183.5C 59.5,188.833 59.5,194.167 59.5,199.5C 55.1667,199.5 50.8333,199.5 46.5,199.5C 46.5,194.167 46.5,188.833 46.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3e61c7",
    d: "M 85.5,183.5 C 86.8333,183.5 88.1667,183.5 89.5,183.5C 89.5,188.833 89.5,194.167 89.5,199.5C 88.1667,199.5 86.8333,199.5 85.5,199.5C 85.5,194.167 85.5,188.833 85.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d60c8",
    d: "M 89.5,183.5 C 91.5,183.5 93.5,183.5 95.5,183.5C 95.5,188.833 95.5,194.167 95.5,199.5C 93.5,199.5 91.5,199.5 89.5,199.5C 89.5,194.167 89.5,188.833 89.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3d5cc8",
    d: "M 95.5,183.5 C 97.8333,183.5 100.167,183.5 102.5,183.5C 102.5,188.833 102.5,194.167 102.5,199.5C 100.167,199.5 97.8333,199.5 95.5,199.5C 95.5,194.167 95.5,188.833 95.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3b56c8",
    d: "M 102.5,183.5 C 103.833,183.5 105.167,183.5 106.5,183.5C 106.5,188.833 106.5,194.167 106.5,199.5C 105.167,199.5 103.833,199.5 102.5,199.5C 102.5,194.167 102.5,188.833 102.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3c53c7",
    d: "M 106.5,183.5 C 107.833,183.5 109.167,183.5 110.5,183.5C 110.5,188.833 110.5,194.167 110.5,199.5C 109.167,199.5 107.833,199.5 106.5,199.5C 106.5,194.167 106.5,188.833 106.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#394dc7",
    d: "M 110.5,183.5 C 112.167,183.5 113.833,183.5 115.5,183.5C 116.488,188.64 116.821,193.974 116.5,199.5C 114.5,199.5 112.5,199.5 110.5,199.5C 110.5,194.167 110.5,188.833 110.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3636c6",
    d: "M 133.5,183.5 C 136.167,183.5 138.833,183.5 141.5,183.5C 141.5,188.833 141.5,194.167 141.5,199.5C 138.833,199.5 136.167,199.5 133.5,199.5C 133.5,194.167 133.5,188.833 133.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#3b34c5",
    d: "M 141.5,183.5 C 144.167,183.5 146.833,183.5 149.5,183.5C 149.5,188.833 149.5,194.167 149.5,199.5C 146.833,199.5 144.167,199.5 141.5,199.5C 141.5,194.167 141.5,188.833 141.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#4132c5",
    d: "M 149.5,183.5 C 152.833,183.5 156.167,183.5 159.5,183.5C 159.5,188.833 159.5,194.167 159.5,199.5C 156.167,199.5 152.833,199.5 149.5,199.5C 149.5,194.167 149.5,188.833 149.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#4830c5",
    d: "M 159.5,183.5 C 167.641,183.481 170.808,187.481 169,195.5C 168.31,197.35 167.144,198.684 165.5,199.5C 163.5,199.5 161.5,199.5 159.5,199.5C 159.5,194.167 159.5,188.833 159.5,183.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.5e6317d7fa6f7c96aeea3e9f586b6163.svg";
export { ForwardRef as ReactComponent };